import * as types from '../actions/actionTypes';
import initialState from "./initialState";

export function selectedResourceCollectionReducer(
    state = initialState.selectedResourceCollection, action
) {
    switch(action.type) {
        case types.FETCH_SELECTED_RESOURCE_COLLECTION:
          return state;
        case types.UPDATE_SELECTED_RESOURCE_COLLECTION:
            return {
                ...state,
                name: action.payload.name,
                id: action.payload.id,
                key: action.payload.key
            };
        default:
          return state;
      }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/selectedResourceCollectionReducer.js